import dateUtil from './dateUtil';

const getPastDateTimeFromDuration = (duration: string, date: string, format: string, dateFormat?: string): string =>
  dateUtil(date, dateFormat).subtract(dateUtil.duration(duration)).format(format);

export default getPastDateTimeFromDuration;
